<template>

    <div id="app">
        <v-app id="_inspire">

            <v-app-bar
                    :clipped-left="$vuetify.breakpoint.lgAndUp"
                    fixed
            >

                <v-toolbar-title class="d-flex">
                    <router-link to="/" tag="span" class="pointer pl-3 pr-5 mt-auto mb-auto">
                        <v-img
                                v-if="!this.$vuetify.theme.dark"
                                alt="Foodison logo"
                                src="@/assets/logo.svg"
                                max-height="auto"
                        ></v-img>
                        <v-img
                                v-else
                                alt="Foodison logo"
                                src="@/assets/d-logo.svg"
                                max-height="auto"
                        ></v-img>
                        <p class="text-caption" style="margin: -13px 0 0 0">v {{appVersion}} </p>
                    </router-link>


                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span class="pt-1">{{dataTime}}</span>
                </v-toolbar-title>

                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                icon
                                v-on="on"
                        >
                            <!--<v-icon>account_circle</v-icon>-->
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                    </template>
                    <template>
                        <v-list>

                            <v-list-item>

                                <v-list-item-content>
                                    <v-list-item-title>{{userName}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>

                            <v-list-item
                                    v-for="(item, i) in toolbarLeftLinks"
                                    :key="i"
                                    :to="item.url"
                                    @click="item.action"
                            >
                                <v-list-item-title>
                                    <v-icon left>{{item.icon}}</v-icon>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>

                    </template>


                </v-menu>


            </v-app-bar>


            <template >
                <v-bottom-navigation
                        absolute
                        :value="activeBtn"
                        grow
                        color="foodison"
                        style="position: fixed;"
                >

                    <v-btn @click="()=>{setTypeOrders([1])}">
                        <span>Везу</span>
                        <v-badge v-if="getCount.t1"
                                 bordered
                                 color="foodison"
                                 :content="getCount.t1"
                                 overlap
                        >
                        <v-icon>directions_car_filled</v-icon>
                        </v-badge>
                        <v-icon v-else>directions_car_filled</v-icon>
                    </v-btn>

                    <v-btn @click="()=>{setTypeOrders([0,2,3])}">
                        <span>Выполнено</span>
                        <v-badge v-if="getCount.t2"
                                bordered
                                color="foodison"
                                :content="getCount.t2"
                                overlap
                        >
                        <v-icon>done_all</v-icon>
                        </v-badge>
                        <v-icon v-else>done_all</v-icon>
                    </v-btn>

                    <v-btn
                            :disabled="getCount.t1>0"
                            @click="()=>{fupdateReady()}"
                            :loading="updateReady"
                    >
                        <template v-if="!ready">
                            <span>Заказы</span>
                            <v-icon>play_arrow</v-icon>
                        </template>
                        <template  v-else>
                            <span>Свободен</span>
                            <v-icon color="foodison">pause</v-icon>
                        </template>
                    </v-btn>

                    <v-btn href="tel:+78007750078">
                        <span>Вызов</span>
                        <v-icon>phone</v-icon>
                    </v-btn>
                </v-bottom-navigation>
            </template>



                <v-content>

                    <router-view/>

                    <template
                            v-if=snackbarMsg
                    >
                        <v-snackbar
                                :multi-line="true"
                                :timeout="7000"
                                :color=snackbarType
                                @input="closeSnackbar"
                                right
                                :value="true"
                        >
                            {{snackbarMsg}}

                            <template v-slot:action="{ attrs }">
                                <v-btn
                                        dark
                                        flat
                                        icon
                                        @click.native="closeSnackbar"
                                >
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>



                        </v-snackbar>
                    </template>

                </v-content>

        </v-app>
    </div>


</template>

<script>

    export default {
        name: 'MainLayout',
        data: () => ({
            dialog: false,
            updateReady: false,
            thumb: true,
            drawer: null,
            activeBtn: 0,
            dataTime: '00:00',
        }),

        computed: {
            appVersion(){
                return process.env.VUE_APP_V
            },
            loading() {
                return false
            },
            ready() {
                return this.$store.getters['courier/ready']
            },
            userName() {
                return this.$store.getters['user/name']
            },
            snackbarType() {
                return this.$store.getters['infoSnackbar/snackbarType']
            },
            snackbarMsg() {
                return this.$store.getters['infoSnackbar/snackbarMsg']
            },
            toolbarLeftLinks() {
                return [
                    {
                        title: 'Обновить', icon: 'update', url: '',
                        action: this.fetchOrders
                    },
                    {
                        title: 'Сменить тему', icon: 'mdi-invert-colors', url: '',
                        action: this.themeDark
                    },
                    {
                        title: 'Выйти', icon: 'exit_to_app', url: '',
                        action: this.onLogout
                    },
                ]
            },
            newItems() {
                return this.$store.getters['menu/menu']
            },
            getCount() {
                return this.$store.getters['courier/count']
            },
        },
        methods: {
            setTypeOrders:  function (types) {
                console.log('log', types);
                this.$store.commit("courier/setTypeOrders", types)
            },
            fetchOrders: async function () {
                this.$store.commit('courier/setLoading', true)
                await this.$store.dispatch("courier/fetchOrders")
                await setTimeout(()=>{
                    this.$store.commit('courier/setLoading', false)
                }, 1)
            },
            onLogout() {
                this.$store.dispatch('user/logoutUser');
                this.$router.push('/login');
                location.reload();
                return true
            },
            closeSnackbar() {
                this.$store.dispatch('infoSnackbar/clearSnackbar')
            },
            actionDefault() {
                return true
            },
            themeDark() {
                this.$vuetify.theme.dark = !this.$vuetify.theme.dark
                localStorage.setItem('theme.dark', this.$vuetify.theme.dark)
            },
            // 'success', 'info', 'error', null
            successSnackbar() {
                this.$store.dispatch('infoSnackbar/clearSnackbar')
                this.$store.dispatch('infoSnackbar/setSnackbarMsg', 'success')
                this.$store.dispatch('infoSnackbar/setSnackbarType', 'success')
            },
            infoSnackbar() {
                this.$store.dispatch('infoSnackbar/clearSnackbar')
                this.$store.dispatch('infoSnackbar/setSnackbarMsg', 'info')
                this.$store.dispatch('infoSnackbar/setSnackbarType', 'info')
            },
            errorSnackbar() {
                this.$store.dispatch('infoSnackbar/clearSnackbar')
                this.$store.dispatch('infoSnackbar/setSnackbarMsg', 'error')
                this.$store.dispatch('infoSnackbar/setSnackbarType', 'error')
            },
            async fupdateReady() {
                this.updateReady = true;
                const ready = (this.ready) ? 0 : 1;
                await this.$store.dispatch('courier/updateReady', ready)
                this.updateReady = false;
            },

        },
        async mounted() {
            //this.$store.dispatch('setLoading', true)
            await this.$store.dispatch('menu/spaMenu')
            //this.$store.dispatch('setLoading', false)
            window.setInterval(()=>{
                const now = new Date();
                this.dataTime = now.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
            }, 1000);
        },

    };
</script>
<style>
    .pointer {
        cursor: pointer;
    }

    .v-btn:not(.v-btn--round).v-size--default {
        height: auto;
    }
</style>
